import { Box, Typography } from '@mui/material';

const OfflineMessage = ({ styles, t, currentDate, isIncludeBreak, startTime, endTime, includeBreakStartTime, includeBreakEndTime }) => {
  return (
    <Box sx={styles.chatContainer}>
      <Box sx={styles.chatDateBox}>
        <Typography sx={styles.chatBubbleDate}>{currentDate}</Typography>
      </Box>

      <Box sx={styles.systemMessage}>
        <Typography sx={{ ...styles.systemText, letterSpacing: '0' }}>{t('4511_chat_unavailable.this_service_is_currently_unavailable')}</Typography>
        <Typography sx={styles.systemText}>{t('4511_chat_unavailable.we_be_back_soon')}</Typography>
        <Typography sx={styles.systemText}>{t('4511_chat_unavailable.thank_you_for_your_patience')}</Typography>
        {isIncludeBreak ? (
          <Typography sx={styles.systemText}>
            {t('4511_chat_unavailable.chat_available_time')} {startTime}-{endTime} {includeBreakStartTime}-{includeBreakEndTime}
          </Typography>
        ) : (
          <Typography sx={styles.systemText}>
            {t('4511_chat_unavailable.chat_available_time')}: {startTime} - {endTime}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default OfflineMessage;
